import { Accordion, AccordionDetails, AccordionSummary, Box, Checkbox, FormControlLabel, IconButton, Typography } from "@mui/material"
import CustomCard from "./CustomCard"
import luciLogo from "../../../assets/luciLogo2.png"
import poweredBy from "../../../assets/poweredBy.svg"
// import { customTheme as theme } from "../../../theme/customTheme"
import { makeStyles } from "@mui/styles";
import {   timeStampToDateTime, timeStampToDayString, timeStampToFormatTimeZone,  } from "../../../utils/commonServices";
import "@fontsource/rubik";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import usePermissions from "../../../hooks/usePermissions";
import { PERMISSION } from "../../../constants/constants";
import { updateCreationState } from "../../../redux/eventCreationSlice";
import CustomButton from "../../../components/CustomButton";
import { updateState } from "../../../redux/commonSlice";
import CustomTooltip from "../../../components/CustomTooltip";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import useCustomTheme from "../../../theme/useCustomTheme";
import { updateProjectState } from "../../../redux/projectSlice";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useState } from "react";
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import StarIcon from '@mui/icons-material/Star';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

const useStyles = makeStyles((theme) => ({
 fontWeightNormal:{
  fontWeight: 'normal'
 }, 
fontWeight:{
  fontWeight:600
},
rubik:{
  fontFamily:'Rubik'
}

}));

const EventDetailCard = (props) => {

  const commonReducer = useSelector((state)=> state.root.commonReducer)
  // const event = commonReducer.events?.find((event) => event.id == commonReducer.production_event_id)
  const themeReducer = useSelector((state) => state.root.themeReducer);
  const dropdownReducer = useSelector((state) => state.root.dropdownReducer);
  const projectReducer = useSelector((state)=> state.projectReducer)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [hasPermission] = usePermissions()
  const [theme ] = useCustomTheme()
  const [selectedVideos, setSelectedVideos] = useState([]);

  const {event} = props
  const [expanded, setExpanded] = useState(0); // Default to the first accordion

  const handleAccordionChange = (panelIndex) => (_, isExpanded) => {
    setExpanded(isExpanded ? panelIndex : 0);
    setSelectedVideos([])
  };

  const handleVideoSelect = (videoId) => {
    setSelectedVideos((prevSelected) => {
      if (prevSelected.includes(videoId)) {
        return prevSelected.filter((id) => id !== videoId); // Deselect video
      } else if (prevSelected.length < 2) {
        return [...prevSelected, videoId]; // Select video if fewer than 2 are selected
      } else {
        // Replace the first selected video if a third is selected
        return [prevSelected[1], videoId];
      }
    });
  };

  // const handleVideoSelect = (videoId) => {
  //   setSelectedVideos((prevSelected) => {
  //     if (prevSelected.includes(videoId)) {
  //       return prevSelected.filter((id) => id !== videoId); // Deselect video
  //     } else if (prevSelected.length < 2) {
  //       return [...prevSelected, videoId]; // Select video if fewer than 2 are selected
  //     }
  //     return prevSelected; // Do nothing if already 2 selected
  //   });
  // };

  // const brandLogo = window.localStorage.getItem('brand_logo_url')
  const brandLogo = themeReducer?.brand_logo

  const classes = useStyles();

  const setPageData = ()=> {
    dispatch(updateCreationState({
        pageData: {
            name : event?.name,
            start_date: event?.start_date,
            end_date: event?.end_date,
            editor_start_date: event?.editor_start_date,
            video_orientation: event?.video_orientation, // landscape | portrait
            // song:'',
            description: event?.description,
           // quality_options: [1],
            event_type_id: dropdownReducer.event_type.find((type)=> type.value == event.event_type)?.id,
            video_length_id: dropdownReducer.video_length.find((length)=> length.value == event.video_length)?.id,
        }
    }))
}

  const editProjectClickHandler =()=>{
    if(event?.status_type_order < 3){
        setPageData()
       dispatch(updateCreationState({open_form: true, edit: true, event_id: event?.id}))
      }else{
         
      dispatch(updateCreationState({edit_decline_popup:true}))
      }
  }

  const openDocumentClickHandler = async ()=>{

      const documentUrl = commonReducer?.event_details?.note_file_url; 
      window.open(documentUrl, '_blank');
  }

  const videoData = [
    {
      version: 'Accordian 1',
      videos: [
        {id:1, title: 'Video 1', thumbnail: 'https://via.placeholder.com/150', url: '#' },
        {id:2, title: 'Video 2', thumbnail: 'https://via.placeholder.com/150', url: '#' },
      ],
    },
    {
      version: 'Accordian 2',
      videos: [
        {id:3, title: 'Video 3', thumbnail: 'https://via.placeholder.com/150', url: '#' },
        {id:4, title: 'Video 4', thumbnail: 'https://via.placeholder.com/150', url: '#' },
        {id:5, title: 'Video 5', thumbnail: 'https://via.placeholder.com/150', url: '#' },
      ],
    },
    {
      version: 'Accordian 3',
      videos: [
        {id:6, title: 'Video 6', thumbnail: 'https://via.placeholder.com/150', url: '#' },
        { id:7,title: 'Video 7', thumbnail: 'https://via.placeholder.com/150', url: '#' },
      ],
    },
  ];


  return (
    <CustomCard className='rubik' style={{ height:'100%', padding:0 , '& .MuiCardContent-root:last-child':{paddingBottom:0}, minWidth:'20vw'}} >
      <Box className="rubik" sx={{height:'100%', display:'flex', flexDirection:'column', paddingY:{xs:'24px',sm:'24px',md:'24px',lg:'30px',xl:'40px'} }}>
        {/* <Box className="rubik flex j-center a-center" sx={{ width: '100%', marginTop:{xs:'25px',sm:'20px',md:'7%', lg: '8%',xl:'8%'}, marginBottom:{xs:'25px',sm:'20px',md:'3%',lg:'4%',xl:'4%'},}} >
          <Box  width='35%'>
           <img src={brandLogo !== null ? brandLogo : luciLogo} width='100%' onClick={()=>navigate('/dashboard', {replace: true})} style={{cursor:'pointer'}}/>
           {
                brandLogo !== null && <Box textAlign='right'><img src={poweredBy}  width='50%'/></Box> 
            }
            </Box>
        
        </Box> */}

        {/* {videoData.map((item, index) => (
        <Accordion
          key={index}
          expanded={expanded === index}
          onChange={handleAccordionChange(index)}
        >
          <AccordionSummary  expandIcon={<ExpandMoreIcon/>}>
            <Typography>{item.version}</Typography>
          </AccordionSummary>
          <AccordionDetails sx={{maxHeight:'250px', overflowY:'auto'}}>
            <Box >
              {item.videos.map((video, idx) => (
                <Box sx={{display:'flex', justifyContent:'space-between', alignItems:'flex-start'}}>
                <Box
                onClick={() => alert(video.id)}
                  key={idx}
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    marginBottom: '16px',
                    
                    height:'80px',
                    width:'150px',
                    borderRadius:'5px',
                    cursor:'pointer',
                    border: selectedVideos.includes(video.id)
                        ? '2px solid #1976d2' // Highlight selected videos
                        : '2px solid #dedede',
                  }}
                > 
              
                
                  <Typography  sx={{ marginTop: '8px' }}>
                    {video.title}
                  </Typography>
                </Box>
                <Checkbox
                 checked={selectedVideos.includes(video.id)} // Updated selection logic
                 onChange={() => handleVideoSelect(video.id)} // Updated to handle checkbox
                />
           
              </Box>
              ))}
            </Box>
          </AccordionDetails>
        </Accordion>
      ))} */}

        <Box className="rubik" sx={{display:'felx', flexDirection:'column', fontSize: {xs:'10px',md:'12px',lg:'14px',xl:'16px'},  marginRight:{md:'10px',lg:'0.52vw',xl:'0.78vw'}}}>
          <Box mb={{xs:0.5,md:0.8,   xl:1.3}} sx={{paddingLeft:{xs:'1.38vw',sm:'1.6vw',md:'1.8vw' ,lg:'2.3vw', xl:'2.9vw'}, mt:3}}>
            <Typography sx={{fontWeight:'normal',  fontSize: {xs:'9px',md:'9px',lg:'10.67px',xl:'16px'}, fontFamily:'Rubik'}}>Lucivideo Name</Typography>
            <Typography sx={{fontWeight:theme.typography.fontWeightBold , fontSize: {xs:'9px',md:'9px',lg:'10.67px',xl:'16px', wordWrap: 'break-word'}, textTransform:'capitalize', fontFamily:'Rubik'}}>{projectReducer?.project_details?.name}</Typography>
          </Box>
          <Box mb={{xs:0.5, md:0.8,  xl:1.3}} sx={{paddingLeft:{xs:'1.38vw',sm:'1.6vw',md:'1.8vw' ,lg:'2.3vw', xl:'2.9vw'}, }}>
            <Typography sx={{color:'#878887' , fontSize: {xs:'9px',md:'9px',lg:'10.67px',xl:'16px'}, fontFamily:'Rubik'}}>Status</Typography>
            <Typography sx={{fontWeight:theme.typography.fontWeightBold , fontSize: {xs:'9px',md:'9px',lg:'10.67px',xl:'16px'}, fontFamily:'Rubik'}}>{projectReducer?.project_details?.status_type}</Typography>
          </Box>
          <Box mb={{xs:0.5, md:0.8,  xl:1.3}}  sx={{paddingLeft:{xs:'1.38vw',sm:'1.6vw',md:'1.8vw' ,lg:'2.3vw', xl:'2.9vw'}, }}>
            <Typography  sx={{color:'#878887' , fontSize: {xs:'9px',md:'9px',lg:'10.67px',xl:'16px'}, fontFamily:'Rubik'}}>Event Type</Typography>
            <Typography sx={{fontWeight:theme.typography.fontWeightBold , fontSize: {xs:'9px',md:'9px',lg:'10.67px',xl:'16px'}, fontFamily:'Rubik'}}>{projectReducer?.project_details?.event_type?.name}</Typography>
          </Box>
          <Box mb={{xs:0.5,md:0.8,   xl:1.3}}  sx={{paddingLeft:{xs:'1.38vw',sm:'1.6vw',md:'1.8vw' ,lg:'2.3vw', xl:'2.9vw'}, }}>
            <Typography  sx={{color:'#878887' , fontSize: {xs:'9px',md:'9px',lg:'10.67px',xl:'16px'}, fontFamily:'Rubik'}}>Start Date</Typography>
            <Typography sx={{fontWeight:theme.typography.fontWeightBold , fontSize: {xs:'9px',md:'9px',lg:'10.67px',xl:'16px'}, fontFamily:'Rubik'}}>{timeStampToDayString(projectReducer?.project_details?.start_date)}, {timeStampToFormatTimeZone(projectReducer?.project_details?.start_date)}</Typography>
          </Box>
      

          <Box mb={{xs:0.5,md:0.8, xl:1.3}}  sx={{paddingLeft:{xs:'1.38vw',sm:'1.6vw',md:'1.8vw' ,lg:'2.3vw', xl:'2.9vw'}, }}>
            <Typography  sx={{color:'#878887' , fontSize: {xs:'9px',md:'9px',lg:'10.67px',xl:'16px'}, fontFamily:'Rubik'}}>Editing Start Date</Typography>
            <Typography sx={{fontWeight:theme.typography.fontWeightBold , fontSize: {xs:'9px',md:'9px',lg:'10.67px',xl:'16px'}, fontFamily:'Rubik'}}>{timeStampToDayString(projectReducer?.project_details?.editor_start_date)}, {timeStampToFormatTimeZone(projectReducer?.project_details?.editor_start_date)}</Typography>
          </Box>

         {/* {  <Box mb={{xs:0.5, md:0.8, xl:1.3}}  sx={{paddingLeft:{xs:'1.38vw',sm:'1.6vw',md:'1.8vw' ,lg:'2.3vw', xl:'2.9vw'}, }}>
            <Box className="flex a-center" gap={{xs:0.5, xl:1}}>
              <Typography  sx={{color:'#878887' , fontSize: {xs:'9px',md:'9px',lg:'10.67px',xl:'16px'}, fontFamily:'Rubik'}}>Notes</Typography>
                
            </Box>

           {commonReducer?.event_details?.description && <Typography onClick={()=> dispatch(updateProjectState({view_notes_to_editor_popup : true}))} sx={{fontWeight:theme.typography.fontWeightBold , fontSize: {xs:'9px',md:'9px',lg:'10.67px',xl:'16px'}, fontFamily:'Rubik', cursor:'pointer', color:theme.palette.secondary.main}}>View Notes</Typography>}

           { <Typography onClick={()=> dispatch(updateProjectState({upload_documents_to_editor_popup : true}))} sx={{fontWeight:theme.typography.fontWeightBold , fontSize: {xs:'9px',md:'9px',lg:'10.67px',xl:'16px'}, fontFamily:'Rubik', cursor:'pointer', color:theme.palette.secondary.main}}>My Documents</Typography>}

           
          </Box>}
           */}

         {(projectReducer?.project_details?.song_type || projectReducer?.project_details?.event_songs?.length > 0 || projectReducer?.project_details?.description || projectReducer?.project_details?.event_notes?.length > 0)  &&  <Box mb={{xs:0.5,md:0.8, xl:1.3}} mt={{xs:3.5,md:3.8, xl:4.3}}  sx={{paddingLeft:{xs:'0.1vw',sm:'0.1vw',md:'0.8vw' ,lg:'1.5vw', xl:'2.3vw'}, }}>
             <Typography sx={{fontSize:{xs:'16px',lg:'20px',xl:'24px'}, ml:1.5, mb:1}}>Client Notes</Typography> 
          </Box>}

          <Box mb={{xs:0.5,md:0.8, xl:1.3}}  sx={{paddingLeft:{xs:'1.38vw',sm:'1.6vw',md:'1.8vw' ,lg:'2.3vw', xl:'2.9vw'}, }}>
        
           {projectReducer?.project_details?.song_type   &&

          <Box className="flex a-center" gap={{xs:0.5, xl:1}}>
              <Typography  sx={{color:'#878887' , fontSize: {xs:'9px',md:'9px',lg:'10.67px',xl:'16px'}, fontFamily:'Rubik'}}>My Music</Typography>
                   <CustomTooltip title={'View music notes.'}  PopperProps={{
                            modifiers: [
                              {
                                name: "offset",
                                options: {
                                  offset: [-35, -4],
                                },
                              },
                            ],
                          }} >
                      <InfoOutlinedIcon onClick={()=> dispatch(updateProjectState({song_desc_popup : true}))} sx={{fontSize: {xs:'9px !important',md:'9px !important',lg:'10.67px !important', xl:'16px !important'}, color:'#08231B', cursor:'pointer'}}/>
                  </CustomTooltip>
            </Box>}


         


            {projectReducer?.project_details?.event_songs?.length > 0 && <Typography onClick={()=> dispatch(updateProjectState({uploaded_songs_popup : true}))} sx={{fontWeight:theme.typography.fontWeightBold , fontSize: {xs:'9px',md:'9px',lg:'10.67px',xl:'16px'}, fontFamily:'Rubik', cursor:'pointer', color:theme.palette.secondary.main}}>Music Files</Typography>}
          </Box>

           <Box mb={{xs:0.5, md:0.8, xl:1.3}}  sx={{paddingLeft:{xs:'1.38vw',sm:'1.6vw',md:'1.8vw' ,lg:'2.3vw', xl:'2.9vw'}, }}>
           {  projectReducer?.project_details?.description  && 
            <Box className="flex a-center" gap={{xs:0.5, xl:1}}>
              <Typography  sx={{color:'#878887' , fontSize: {xs:'9px',md:'9px',lg:'10.67px',xl:'16px'}, fontFamily:'Rubik'}}>Notes</Typography>
                  { <CustomTooltip title={'View project notes.'}  PopperProps={{
                            modifiers: [
                              {
                                name: "offset",
                                options: {
                                  offset: [-35, -4],
                                },
                              },
                            ],
                          }} >
                      <InfoOutlinedIcon onClick={()=> dispatch(updateProjectState({view_notes_to_editor_popup : true}))} sx={{fontSize: {xs:'9px !important',md:'9px !important',lg:'10.67px !important', xl:'16px !important'}, color:'#08231B', cursor:'pointer'}}/>
                  </CustomTooltip>}
            </Box>}


           { projectReducer?.project_details?.event_notes?.length > 0 &&   <Typography onClick={()=> dispatch(updateProjectState({uploaded_documents_to_editor_popup : true}))} sx={{fontWeight:theme.typography.fontWeightBold , fontSize: {xs:'9px',md:'9px',lg:'10.67px',xl:'16px'}, fontFamily:'Rubik', cursor:'pointer', color:theme.palette.secondary.main}}>My Documents</Typography>}

          </Box>




        </Box>
        {/* { ( hasPermission(PERMISSION.PROJECT.INFO.EDIT) &&  (commonReducer?.event_details?.status_type_order < 3) ) && 
          <Box className='flex col j-end a-center' sx={{flex: 2}} mt={{xs:1, md:1,xl:2}}>
            <CustomButton 
              btnText='Edit Project'
              onClick={editProjectClickHandler}
              type='button'    
              color='secondary'
              variant='contained'
              style={{
                borderRadius: '5px',
                border: "none",
                textTransform:'none',
              
                }}
              endIcon={<EditOutlinedIcon style={{fontSize:'14px'}} />}
              sx={{fontSize:{xs:'8px',sm:'9px',lg:'11px',xl:'16px'},  fontWeight:600, height:{xs:'18px',sm:'18px',lg:'22px',xl:"36px"}, width: '100%', maxWidth: {xs:'120px', xl:'180px'} , fontFamily:'Rubik'}}
            />
            </Box> } */}

            {/* {selectedVideos.length === 2 && (
              <Box className='flex col j-end a-center' sx={{flex: 2}} mt={{xs:1, md:1,xl:2}}>
              <CustomButton 
              btnText='Compare'
              onClick={()=>  dispatch(updateProjectState({compare_videos_popup : true})) }
              type='button'    
              color='secondary'
              variant='contained'
              style={{
                borderRadius: '5px',
                border: "none",
                textTransform:'none',
              
                }}

              sx={{fontSize:{xs:'8px',sm:'9px',lg:'11px',xl:'16px'},  fontWeight:600, height:{xs:'18px',sm:'18px',lg:'22px',xl:"36px"}, width: '100%', maxWidth: {xs:'120px', xl:'180px'} , fontFamily:'Rubik'}}
            />
            </Box>
        ) } */}
      </Box>
    </CustomCard>
  )
}

export default EventDetailCard